import { NgModule } from '@angular/core';
import { InProgressDirective } from './in.progress/in-progress.directive';
import { FieldErrorsDirective } from './field.errors/field-errors.directive';
import { ClearOnForcusDirective } from './clear.on.focus/clear-on-forcus.directive';
import { RadioCheckboCustomColorDirective } from './radio-checkbo-custom-color.directive';
import { DropdownHoverDirective } from './dropdown-hover.directive';

@NgModule({
    declarations: [
        InProgressDirective,
        FieldErrorsDirective,
        ClearOnForcusDirective,
        RadioCheckboCustomColorDirective,
        DropdownHoverDirective
    ],
    imports: [
    ],
    exports: [
        InProgressDirective,
        FieldErrorsDirective,
        ClearOnForcusDirective,
        RadioCheckboCustomColorDirective,
        DropdownHoverDirective,
    ],
    providers: [
    ],
})
export class DirectivesModule { }
